export default "__VITE_ASSET__92c7ca3f__"